import { getAccessToken } from '@rsmus/react-auth';
import { CemServiceClient, IAuthClientConfig } from '@rsmus/xcelerate-cemservice';
import { envProperties } from 'utils/EnvironmentProperties';

  const config: IAuthClientConfig = {
    getAuthorization: async () => {
      return getAccessToken().then((at) => `Bearer ${  at}`);
    },
  };

export const cemServiceClient = new CemServiceClient(config, envProperties.CemBaseUrl);